/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.

 *  */

import * as Utils from "@Cyclope-Utils/index";
import * as moment from "moment";
// import * as moment from 'moment-timezone';

/**
 * Vérification du Token
 * @function TunnelToken
 * @param {}
 * @return { any }
 */
const TunnelToken = (): any =>
  Utils.localStorageIsKeyExist() && Utils.localStorageIsKeyExist();

/**
 * Configuration dela viriable globale , L'objet window représente une fenêtre
 * contenant un document DOM
 */
const API_URL = "env";

/**
 * fetchTunnelWatchImpactsCamera : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function fetchTunnelWatchAllImpactsCamera
 * @param {}
 * @method 'POST'
 */
export const fetchTunnelWatchAllImpactsCamera = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/findAll";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchTunnelWatchImpactsCamera : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function exportCameraAllCsv
 * @param {}
 * @method 'POST'
 */
export const exportCameraAllCsv = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findAll/export";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
  });
};
/**
 * fetchTunnelIncidents : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchTunnelIncidents
 * @param { number } currentPage
 * @param { number } itemPerPage
 * @method 'GET'
 */
export const fetchTunnelIncidents = (
  currentPage: number,
  itemPerPage: number,
  incidents: string
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/incidents/findAllPagination?page=" +
    currentPage +
    "&size=" +
    itemPerPage +
    "" +
    incidents +
    "";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
  });
};

/**
 * fetchTunnelWatchIncidentById : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function fetchTunnelWatchIncidentById
 * @param { number } id
 * @method 'POST'
 */
export const fetchTunnelWatchIncidentById = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/findById";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * tunnelWatchImpactIsQualified : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function tunnelWatchImpactIsQualified;
 * @param {number } impoactId
 * @param {number }  iQuality
 * @method 'POST'
 */
export const tunnelWatchImpactIsQualified = (
  impactId: number,
  isQualify: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/saveQualification";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id: impactId, qualification: isQualify }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * tunnelWatchImpactIsReQualified : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchImpactIsReQualified;
 * @param {number } impoactId
 * @param {number }  iQuality
 * @method 'POST'
 */
export const tunnelWatchImpactIsReQualified = (
  impactId: number,
  isQualify: number,
  isMotif: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/saveQualification";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      id: impactId,
      qualificationMotif: isMotif,
      qualification: isQualify,
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * tunnelWatchImpactFakeDeleted : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function tunnelWatchImpactFakeDeleted;
 * @param {number } impoactId
 * @param {number }  iQuality
 * @method 'DELETE'
 */
export const tunnelWatchImpactFakeDeleted = (
  impactId: number,
  isQualify: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/deleteFake/" + impactId + "";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id: impactId }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "DELETE",
  });
};
/**
 * tunnelWatchExploreImpactsHistory : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchExploreImpactsHistory
 * @param {}
 * @method 'POST'
 */
export const tunnelWatchExploreImpactsHistory = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/history";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
    mode: "cors",
  });
};

/**
 * checkNewIncidents : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchCheckcamerazonemask
 * @param { number } cameraIdentifiant
 * @param { number } zoneIdentifiant
 * @method 'GET'
 */
export const fetchCheckcamerazonemask = (
  cameraIdentifiant: number,
  zoneIdentifiant: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/cameras/checkZones?cameraId=" +
    Number(cameraIdentifiant) +
    "&zoneId=" +
    Number(zoneIdentifiant);
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
    mode: "cors",
  });
};

/**
 * checkincidentsisnotqualify : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function checkincidentsisnotqualify
 * @param { number } incidents
 * @method 'GET'
 */
export const checkincidentsisnotqualify = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/toQualified";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
    mode: "cors",
  });
};
/**
 * checkNewIncidents : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function checkNewIncidents
 * @param { number } incidents
 * @method 'GET'
 */
export const checkNewIncidents = (incidents: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/check?nb=" + incidents;
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
    mode: "cors",
  });
};
/**
 * tunnelIncidentHistory : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function tunnelIncidentHistory
 * @param {number }  currentPage
 * @param {number }  itemPerPage
 * @param {string }  action
 * @method 'GET'
 */
export const tunnelIncidentHistory = (
  currentPage: number,
  itemPerPage: number,
  action: string
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/incidents/historyPagination?" +
    action +
    "&page=" +
    currentPage +
    "&size=" +
    itemPerPage +
    "";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Authorization: String("Bearer " + TunnelToken()),
    },

    method: "GET",
  });
};

/**
 * tunnelWatchImpactsHistory : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function tunnelWatchImpactsHistory
 * @param {}
 * @method 'POST'
 */
export const tunnelWatchImpactsHistory = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/legacyAlarms/findAll";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * tunnelWatchNotificationCount : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function tunnelWatchNotificationCount
 * @param {}
 * @method 'POST'
 */
export const tunnelWatchNotificationCount = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/findAllPagination?page=0&size=1";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
  });
};
/**
 * tunnelWatchNotificationCount : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function tunnelWatchNotificationCount
 * @deprecated
 * @param {}
 * @method 'POST'
 */
/*
export const tunnelWatchNotificationCount = () => {
    const URL_DAI: any = window[API_URL].API_URL_STATIC;
    const API_BATCH = URL_DAI + '/incidents/count';
    return fetch(API_BATCH, {
        cache: 'default',

        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: String('Bearer ' + TunnelToken()),
            'Content-Type': 'application/json',
        },

        method: 'POST',
    });
};
/**
 * tunnelWatchGetOnImpactsHistory : Manipulation ( appel ou MAJ) des données
avec l'API Fetch,
 * @function tunnelWatchGetOnImpactsHistory
 * @param {number } impactId
 * @method 'POST'
 */
export const tunnelWatchGetOnImpactsHistory = (impactsId: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sequence/get";

  return fetch(API_BATCH, {
    body: JSON.stringify({ id: impactsId }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchSupervisorAllCamera : Manipulation ( appel ou MAJ) des données avec
 * l'API Fetch,
 * @function fetchSupervisorAllCamera
 * @param {}
 * @method 'POST'
 */
export const fetchSupervisorAllCamera = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findAll";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchCameraBySection : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchCameraBySection
 * @param { number } sectionId
 * @method 'GET'
 */
export const fetchCameraBySection = (sectionId: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findBySectionId/" + sectionId;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};

/**
 * fetchMoveCamera : renvoie les headers sous la forme d'une promesse,
 * @function fetchMoveCamera
 * @param { number } id
 * @method 'POST'
 */
export const fetchMoveCamera = (id: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/segment";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};
/**
 * fetchCameraById : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchCameraById
 * @param { number } id
 * @method 'POST'
 */
export const fetchCameraById = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findById";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchSystemSettings :
 * @function fetchSystemSettings
 * @param {  }
 * @method 'POST'
 */
export const fetchSystemSettings = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/findAll";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * fetchSectionSettings :
 * @function fetchSectionSettings
 * @param { number } id
 * @method 'POST'
 */
export const fetchSectionSettings = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/findById";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * updateSectionById : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function updateSectionById
 * @param { any } state
 * @method 'POST'
 */
export const updateSectionById = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/saveSection";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      color: state.color,
      id: state.id,
      length: state.length,
      mileage_end: state.mileageEnd,
      mileage_start: state.mileageStart,
      name: state.name,
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * tunnelWatchSupervisorCameraCreated : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchSupervisorCameraCreated
 * @param {any } state
 * @method 'POST'
 */

export const tunnelWatchSupervisorCameraCreated = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/saveCamera";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      code: state.nameCamera.toUpperCase(),
      proposedMaxDistance: state.proposedMaxDistance ? Number(state.proposedMaxDistance) : null,
      direction: Number(state.directionCamera),
      id: state.idCamera,
      ip: state.ipCamera,
      location: Number(state.lineaireLocalisationCamera),
      route: state.infrastructureCamera,
      section: {
        // 'id':Number(state.sectionCamera.id)
        id: Number(state.sectionCamera),
      },
      type: state.typeCamera,
      view: state.viewCamera,
      proxyCode: state.proxyCode,
      stream: state.stream
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * tunnelWatchSupervisorCameraRemove : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchSupervisorCameraRemove
 * @param {number } identifiant
 * @method 'POST'
 */
export const tunnelWatchSupervisorCameraRemove = (identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/" + identifiant;
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "DELETE",
  });
};

/**
 * tunnelWatchSupervisorCameraUpdate : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchSupervisorCameraUpdate
 * @param {any } state
 * @method 'POST'
 */
export const tunnelWatchSupervisorCameraUpdate = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/updateCamera ";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      code: state.nameCameraUpdate.toUpperCase(),
      proposedMaxDistance: state.proposedMaxDistance ? Number(state.proposedMaxDistance) : null,
      direction: Number(state.directionCamera),
      id: Number(state.idCamera),
      ip: state.ipCameraUpdate,
      location: Number(state.lineairelocalisationCameraUpdate),
      route: state.infrastructureCamera,
      section: { id: Number(state.sectionCamera) },
      type: state.typeCamera,
      view: state.viewCamera,
      proxyCode: state.proxyCode,
      stream: state.stream
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "PUT",
  });
};

/**
 * fetchExtractVideo : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchExtractVideo
 * @param { any } incidentParams
 * @method 'GET'
 */
export const fetchExtractVideo = (incidentParams: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/sequences/export";

  const duration = incidentParams.duration === 0 ? 30 : incidentParams.duration;

  const startDateTime =
    incidentParams.duration === 0
      ? moment
          .utc(incidentParams.startDateTime)
          .subtract(15, "seconds")
          .toDate()
          .toISOString()
      : incidentParams.startDateTime;

  const params = [
    ["cameraId", incidentParams.selectedCamera],
    ["duration", duration],
    ["starttime", startDateTime],
  ];

  if (incidentParams.incidentId !== null) {
    params.push(["incidentId", Number(incidentParams.incidentId)]);
  }

  return fetch(API_BATCH + "?" + new URLSearchParams(params), {
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
    mode: "cors",
  });
};

/**
 * fetchExtractPdf : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchExtractPdf
 * @param { any } incidentParams
 * @method 'POST'
 */
export const fetchExtractPdf = (incidentParams: any) => {
  const ENV = "env";
  const lang = window[ENV].LANGUAGE;

  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI + "/incidents/downloadPdf/" + incidentParams + "?lang=" + lang;

  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
    mode: "cors",
  });
};

/**
 * tunnelWatchFetchImpactsHistory : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function tunnelWatchFetchImpactsHistory
 * @param {  }
 * @method 'POST'
 */

export const tunnelWatchFetchImpactsHistory = (
  current: number,
  items: number,
  sorting: string
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/legacyAlarms/findAll?page=" +
    current +
    "&size=" +
    items +
    "&" +
    sorting +
    "";

  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * tunnelWatchFetchOneImpactsHistoryById : Manipulation ( appel ou MAJ) des
 * données avec l'API Fetch,
 * @function tunnelWatchFetchOneImpactsHistoryById
 * @param { number } id
 * @method 'POST'
 */
export const tunnelWatchFetchOneImpactsHistoryById = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sequence/get";

  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),

    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};
/**
 * searchIncidentById : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function searchIncidentById
 * @param { number } id
 * @method 'POST'
 */
export const searchIncidentById = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/findById";

  return fetch(API_BATCH, {
    body: JSON.stringify({ id }),

    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * authenticateUser : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function authenticate
 * @param { any } user
 * @method 'POST'
 */
export const authenticateUser = (user: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/authenticate";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      password: String(user.password),
      rememberMe: false,
      username: String(user.identifiant),
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    method: "POST",
    // mode: 'cors',
  });
};
/**
 * authorisations : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function authorisations
 * @param { any } user
 * @method 'POST'
 */
export const authorisations = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/users/allauthoritie";

  return fetch(API_BATCH, {
    // body: JSON.stringify({}),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: String("Bearer " + TunnelToken()),
    },

    method: "GET",
    // mode: 'cors',
  });
};
/**
 * userRight : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function userRight
 * @param { any } user
 * @method 'POST'
 */
export const userRight = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/users/roles";

  return fetch(API_BATCH, {
    // body: JSON.stringify({}),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: String("Bearer " + TunnelToken()),
    },

    method: "GET",
    // mode: 'cors',
  });
};
/**
 * changeUserPassWord : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function changeUserPassWord
 * @param { any } user
 * @method 'POST'
 */
export const changeUserPassWord = (user: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/account/change-password";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      currentPassword: String(user.pwdHold),
      newPassword: String(user.pwdConfirm),
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * requestPasswordReset : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function requestPasswordReset
 * @param { any } userMail
 * @method 'POST'
 */
export const requestPasswordReset = (userMail: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/account/reset-password/init";

  return fetch(API_BATCH, {
    body: userMail,

    cache: "default",

    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
    },

    method: "POST",
  });
};

/**
 * finishPasswordReset : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function finishPasswordReset
 * @param { any } keyAndPassword
 * @method 'POST'
 */
export const finishPasswordReset = (keyAndPassword: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/account/reset-password/finish";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      key: String(keyAndPassword.key),
      newPassword: String(keyAndPassword.newpassword),
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};
/**
 * fetchCameraBeforeAndAfterByLocation : Manipulation ( appel ou MAJ) des
 * données avec l'API Fetch,
 * @function fetchCameraBeforeAndAfterByLocation
 * @param { number  } direction
 * @param { number  } location
 * @method 'POST'
 */
export const fetchCameraBeforeAndAfterByLocation = (
  direction: number,
  location: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findBeforeAfter";
  return fetch(API_BATCH, {
    body: JSON.stringify({ direction, location }),

    cache: "default",

    headers: {
      Accept: "application/json",

      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchTunnelWatchZonemaskByCameraId : Manipulation ( appel ou MAJ) des données
 * avec l'API Fetch,
 * @function fetchTunnelWatchZonemaskByCameraId
 * @param { number  } cameraId
 * @param { number  } zoneId
 * @method 'POST'
 */
export const fetchTunnelWatchZonemaskByCameraId = (
  cameraId: number,
  zoneId: number
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/getZone";
  return fetch(API_BATCH, {
    body: JSON.stringify({ cameraId, zoneId }),

    cache: "default",

    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchTunnelWatchAllZone : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchTunnelWatchAllZone
 * @param {   }
 * @method 'POST'
 */
export const fetchTunnelWatchAllZone = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/zones/findAll";

  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),

      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * fetchCameraInhibitions : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchCameraInhibitions
 * @param { number   } cameraId
 * @method 'POST'
 */
export const fetchCameraInhibitions = (cameraId: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/getInhibitions";

  return fetch(API_BATCH, {
    body: JSON.stringify({ id: cameraId }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),

      "Content-Type": "application/json",
    },

    method: "POST",
  });
};
/**
 * fetchIncidentTypes: Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchIncidentTypes
 * @param {}
 * @method 'POST'
 */
export const fetchIncidentTypes = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/types/findAll";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchLocalInhibition
 * @param {}
 * @method 'GET'
 */
export const fetchLocalInhibition = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/findAll";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * downloadLapiPdf : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function downloadLapiPdf
 * @param { any } incidentParams
 * @method 'POST'
 */
export const downloadLapiPdf = (incidentParams: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/lapi/downloadPdf/" + incidentParams;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
    mode: "cors",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function downloadLapiPdfAll
 * @param {}
 * @method 'GET'
 */
export const downloadLapiPdfAll = (
  current: number,
  items: number,
  sorting: string
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/lapi/findAllPagination/export?page=" +
    current +
    "&size=" +
    items +
    "&" +
    sorting +
    "";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchLapiAndTmp
 * @param {}
 * @method 'GET'
 */
export const fetchLapiAndTmp = (
  current: number,
  items: number,
  sorting: string
) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI +
    "/lapi/findAllPagination?page=" +
    current +
    "&size=" +
    items +
    "&" +
    sorting +
    "";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function TmdQualification
 * @param { any } inhibate
 * @method 'POST'
 */
export const TmdQualification = (identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH =
    URL_DAI + "/lapi/cameras/" + identifiant + "/acknowledgment";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchLapiAndTmpAllCamera
 * @param {}
 * @method 'GET'
 */
export const fetchLapiAndTmpAllCamera = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/lapi/cameras";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function findTMD
 * @param {}
 * @method 'GET'
 */
export const findTMD = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/lapi/cameras/tmd?acknowledged=false";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function
 * @name fetchCameraInhibition
 * @param { number } idCamera
 * @method 'GET'
 */
export const fetchCameraInhibition = (idCamera: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/findAll/" + idCamera;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function
 * @name fetchCameraInhibitionLoaded
 * @param { number } idCamera
 * @method 'GET'
 */
export const fetchCameraInhibitionLoaded = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/findAll/";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function
 * @name fetchInhibitionByCameraLoaded
 * @param { number } idCamera
 * @method 'GET'
 */
export const fetchInhibitionByCameraLoaded = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/findAllCameras";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function removeLocalInhibitionById
 * @param { number } inhibitionId
 * @method 'DELETE'
 */
export const removeLocalInhibitionById = (inhibitionId: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/delete/" + inhibitionId + "";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "DELETE",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchIncidentsInhibitionGlobal
 * @param {}
 * @method 'POST'
 */
export const fetchIncidentsInhibitionGlobal = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/inhibitions/findAll";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchCameraInhibate
 * @param { any } inhibate
 * @method 'POST'
 */
export const fetchCameraInhibate = (inhibate: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/inhibate";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      id: {
        cameraId: Number(inhibate.cameraId),
        incidentTypeId: Number(inhibate.typeOfIncident),
      },
      isSet: inhibate.isSet,
    }),
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function settingCameraInhibate
 * @param { any } inhibate
 * @method 'POST'
 */
export const settingCameraInhibate = (inhibate: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/updateCamera";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      camera: {
        id: Number(inhibate.cameraIdentifiant),
      },
      incidentTypes: inhibate.incidenTypeIdentifiantByCheckBox.filter(
        (elem: any) => elem !== null
      ),
    }),
    cache: "default",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchIncidentsInhibition
 * @param { }
 *
 * @method 'POST'
 */
export const fetchIncidentsInhibition = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/inhibitions/findAll";
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchIncidentInhibate
 * @param { any } action
 * @method 'POST'
 */
export const fetchIncidentInhibate = (action: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/inhibate";
  return fetch(API_BATCH, {
    body: JSON.stringify({
      first: {
        incidentTypes: action.identifiantIncident.filter(
          (elem: any) => elem !== null
        ),
      },
      second: action.rulesObject,
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "PUT",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchSaveIncidentType
 * @param {any  } incidentrules
 * @method 'POST'
 */
export const fetchSaveIncidentType = (incidentrules: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/types/saveIncidentType";
  return fetch(API_BATCH, {
    body: JSON.stringify(incidentrules),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchAllRulesExtractVideo
 * @param {  }
 * @method 'GET'
 */
export const fetchAllRulesExtractVideo = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/rules/videos/extraction/";

  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchAllRulesExtractVideo
 * @param {  }
 * @method 'GET'
 */
export const fetchAllRulesUpdateVideo = (elem: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/rules/videos/extraction/" + elem.id + "";

  return fetch(API_BATCH, {
    body: String(elem.value),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "PUT",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchAllRulesDisplay
 * @param {  }
 * @method 'GET'
 */
export const fetchAllRulesDisplay = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/display/rules/";

  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function updateRuleValue
 * @param {any  } value
 * @param { number} id
 * @method 'PUT'
 */
export const updateRuleValue = (value: any, id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/display/rules/" + id + "";

  return fetch(API_BATCH, {
    body: String(value),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "PUT",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function saveFakeIncidents
 * @param { any } state
 * @method 'POST'
 */
export const saveFakeIncidents = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/saveFake";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      cameraId: state.cameraId,
      endTime: moment(state.endDate).format("YYYY-MM-DD HH:mm:ss"),
      incidentTypeId: state.typeincident,
      startTime: moment(state.startDate).format("YYYY-MM-DD HH:mm:ss"),
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch, @@@
 * @function fetchSetSectionSettings
 * @param { number  } sectionsettings
 * @method 'POST'
 */
export const fetchSetSectionSettings = (sectionsettings: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/saveSection";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      color: "string",
      id: 0,
      mileageEnd: 0,
      mileageStart: 0,
      name: "string",
      typeId: 0,
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchSimulatorIncident
 * @param {}
 * @method 'POST'
 */
export const fetchSimulatorIncident = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/findAll";

  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchSectionZones
 * @param { number } section
 * @method 'POST'
 */
export const fetchSectionZones = (section: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/getZones";
  return fetch(API_BATCH, {
    body: JSON.stringify({ id: Number(section) }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchSectionSaveZone
 * @param { number  } trafficdirection
 * @method 'POST'
 */
export const fetchSectionSaveZone = (trafficdirection: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/saveZone";

  return fetch(API_BATCH, {
    body: JSON.stringify(trafficdirection),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function InhibionCreatedBySections
 * @param { any } state
 * @method 'POST'
 */
export const InhibionCreatedBySections = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/inhibate";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      endtime: moment(state.endDate).format("YYYY-MM-DD HH:mm:ss"),
      id: {
        incidentTypeId: 1,
        sectionId: 1,
      },
      isSet: true,
      starttime: moment(state.startDate).format("YYYY-MM-DD HH:mm:ss"),
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function InhibionCreatedByCamera
 * @param { any } state
 * @method 'POST'
 */
export const InhibionCreatedByCamera = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;

  const API_BATCH = URL_DAI + "/cameras/inhibate";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      endtime: moment(state.endDate).format("YYYY-MM-DD HH:mm:ss"),
      id: {
        cameraId: 1,
        incidentTypeId: 1,
      },
      isSet: true,
      starttime: moment(state.startDate).format("YYYY-MM-DD HH:mm:ss"),
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function replayOfIncident
 * @param { number } id
 * @method 'GET'
 */
export const replayOfIncident = (id: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/" + id + "/replay";

  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",

      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
    mode: "cors",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function localInhibitionCreatedBy
 * @param { any } state
 * @method 'POST'
 */
export const localInhibitionCreatedBy = (state: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/inhibitions/create";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      cameras: state.cameraArray.filter((elem: any) => elem !== null),
      endtime: moment(state.endDate).format("YYYY-MM-DD HH:mm:ss"),
      incidentTypes: state.incidenTypeId.filter((elem: any) => elem !== null),
      sections: state.radioId.filter((elem: any) => elem !== null),
      starttime: moment(state.startDate).format("YYYY-MM-DD HH:mm:ss"),
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function cameraSwitchSegmented
 * @param { number  } Identifiant
 * @method 'POST'
 */
export const cameraSwitchSegmented = (Identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/switchSegmented/" + Identifiant;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function sectionSwitchSegmented
 * @param { number } Identifiant
 * @method 'POST'
 */
export const sectionSwitchSegmented = (Identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/switchSegmented/" + Identifiant;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "GET",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function sectionSwitchSegmentedReset
 * @param { number } Identifiant
 * @method 'GET'
 */
export const sectionSwitchSegmentedResetAll = (Identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/resetAllCameras/" + Identifiant;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "PUT",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function cameraSwitchSegmentedReset
 * @param { number } Identifiant
 * @method 'GET'
 */
export const cameraSwitchSegmentedReset = (Identifiant: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/sections/resetCamera/" + Identifiant;
  return fetch(API_BATCH, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "PUT",
  });
};

/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function cameraUpdateZone
 * @param { any } state
 * @param { any } stateIdent
 * @method 'POST'
 */
export const cameraUpdateZone = (state: any, stateIdent: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/cameras/updateZone";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      id: { cameraId: state.camera.id, zoneId: state.zone },
      polygons: state.coordToDataScientist,
      stateId: stateIdent,
    }),
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    method: "POST",
  });
};
/**
 * Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function versionning
 * @param {}
 * @method 'GET'
 */
export const versionning = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/version";
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
  });
};

// Profiles utilisateurs

/**
 * fetchAllUsers : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function fetchAllUsers
 * @param { any } user
 * @method 'POST'
 */
export const fetchAllUsers = () => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/users";

  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
  });
};
/**
 * removedUser : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function removedUser
 * @param { any } user
 * @method 'POST'
 */
export const removedUser = (IdentifiantUser: string) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/users/" + IdentifiantUser + "";

  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "DELETE",
  });
};

/**
 * createdUser : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function createdUser
 * @param { any } user
 * @method 'POST'
 */
export const createdUser = (users: any) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;

  const ENV = "env";
  const lang = window[ENV].LANGUAGE;

  const API_BATCH = URL_DAI + "/users";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      activated: true,
      email: users.emailUserAdd,
      firstName: users.firstNameUserAdd,
      lastName: users.nameUserAdd,
      authorities: users.roleUserAdd,
      login: users.loginUserAdd,
      langKey: lang,
    }),

    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "POST",
  });
};

/**
 * updatedUser : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function updatedUser
 * @param { any } user
 * @method 'POST'
 */
export const updatedUser = (user: any) => {
  const ENV = "env";
  const lang = window[ENV].LANGUAGE;

  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/users";

  return fetch(API_BATCH, {
    body: JSON.stringify({
      activated: true,
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      authorities: user.authorities,
      login: user.login,
      langKey: lang,
    }),

    cache: "default",

    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "PUT",
  });
};

/**
 * fetchStatsByCamera : Manipulation ( appel ou MAJ) des données avec l'API
 * Fetch,
 * @function fetchStatsByCamera
 * @param { number } identifiant
 * @param { number } period
 * @method 'GET'
 */
export const fetchStatsByCamera = (identifiant: number, period: number) => {
  const URL_DAI: any = window[API_URL].API_URL_STATIC;
  const API_BATCH = URL_DAI + "/incidents/report/" + identifiant + "/" + period;
  return fetch(API_BATCH, {
    cache: "default",

    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },

    method: "GET",
    mode: "cors",
  });
};



// WEBPACK FOOTER //
// ./src/Utils/fetch/index.ts